import {FC} from 'react';

import {Typography, useMediaQuery} from '@mui/material';

import ChevronLeftIcon from 'assets/icons/chevronLeft';
import ThinChevronLeft from 'assets/icons/thinChevronLeft';
import AddressDrawerAppHeader from 'components/app-header-container/BasketAppHeader';
import theme from 'config/theme';
import ReactNative from 'services/react-native';

import {
  StyleAddressDrawerHeaderContainer,
  StyleAddressDrawerHeaderWrapper,
  StyledAddressDrawerHeader,
  StyledIconButton
} from './styles';

export type AddressDrawerHeaderProps = {
  title: string;
  onBack?: () => void;
};

export const AddressDrawerHeader: FC<AddressDrawerHeaderProps> = ({title, onBack}) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();
  const isMobileView = useMediaQuery(theme.breakpoints.only('mobile'));
  const isMobileScreen = isReactNativeView || isMobileView;

  const AddressDrawerHeaderTitle = (props?: {fontSize?: string; fontWeight?: string}) => (
    <Typography
      component={'h4'}
      variant="h4"
      flexGrow={1}
      id="lbl_title_shippng_address"
      fontSize={props?.fontSize}
      fontWeight={props?.fontWeight}
    >
      {title}
    </Typography>
  );

  return (
    <StyleAddressDrawerHeaderWrapper>
      <StyleAddressDrawerHeaderContainer isReactNativeView={isMobileScreen}>
        {isMobileScreen ? (
          <AddressDrawerAppHeader
            leadingElement={
              <StyledIconButton type="button" onClick={onBack}>
                <ThinChevronLeft width={24} height={24} />
              </StyledIconButton>
            }
            headerTitle={<AddressDrawerHeaderTitle fontSize={'20px'} fontWeight={'700'} />}
          />
        ) : (
          <StyledAddressDrawerHeader>
            <StyledIconButton type="button" onClick={onBack}>
              <ChevronLeftIcon width={28} height={28} />
            </StyledIconButton>
            <AddressDrawerHeaderTitle />
          </StyledAddressDrawerHeader>
        )}
      </StyleAddressDrawerHeaderContainer>
    </StyleAddressDrawerHeaderWrapper>
  );
};

AddressDrawerHeader.displayName = 'AddressDrawerHeader';
export default AddressDrawerHeader;
